import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { JudgePhaseProjectDocumentType } from "../../types/ScientificModule";
import { get, post, put } from "../../utils/axios-config";
import { JUDGE_PHASE_PROJECT_DOCUMENTS } from "../../utils/constants";

export const createJudgePhaseProjectDocument = async (data: JudgePhaseProjectDocumentType) => await post<JudgePhaseProjectDocumentType, string>(JUDGE_PHASE_PROJECT_DOCUMENTS, data);
export const updateJudgePhaseProjectDocument = async (data: JudgePhaseProjectDocumentType) => await put<JudgePhaseProjectDocumentType, string>(JUDGE_PHASE_PROJECT_DOCUMENTS, data);

export const getJudgePhaseProjectDocuments = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdJudgePhaseProject ? { IdJudgePhaseProject: data.IdJudgePhaseProject  } : {}),
    });
    const url = `${JUDGE_PHASE_PROJECT_DOCUMENTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<JudgePhaseProjectDocumentType>>(url);
};

 